import React, { Component } from 'react'
import { Button, Pane } from 'evergreen-ui'
import { Auth } from "aws-amplify"
import { AuthContext } from '../../contexts/auth'
import { withRouter, Link } from 'react-router-dom';

class Logout extends Component {
  handleLogout = async event => {
    await Auth.signOut();
    this.context.userHasAuthenticated(false)
    this.context.userIsAdmin(false)
    this.context.clearRoles()
    this.context.clearOrgType()
    this.props.history.push('/');
  }

  render() {
    return (
      <Pane marginLeft={8}>
        <Link to="/">
          <Button
            marginRight={12}
            iconBefore='log-out'
            onClick={this.handleLogout}
          >
            Sign out
          </Button>
        </Link>
      </Pane>
    )
  }
}

Logout.contextType = AuthContext;

export default withRouter(Logout)